import React from 'react';
import { Tag } from 'antd';

type StatusType = 'draft' | 'sent' | 'accepted' | 'rejected' | 'expired';

interface QuoteStatusTagProps {
  status: StatusType;
}

const statusColors: Record<StatusType, string> = {
  draft: 'default',
  sent: 'processing',
  accepted: 'success',
  rejected: 'error',
  expired: 'warning',
};

const statusLabels: Record<StatusType, string> = {
  draft: 'Brouillon',
  sent: 'Envoyé',
  accepted: 'Accepté',
  rejected: 'Rejeté',
  expired: 'Expiré',
};

const QuoteStatusTag: React.FC<QuoteStatusTagProps> = ({ status }) => {
  return <Tag color={statusColors[status]}>{statusLabels[status]}</Tag>;
};

export default QuoteStatusTag;
